import React, {useEffect} from 'react'

const mountPreview = ({id}) => {
    const oldCanvas = document.querySelector(`#entity-preview-${id}`)
    const newCanvas = document.createElement('canvas')
    const context = newCanvas.getContext('2d')
    const parent = document.querySelector(`#entity-preview-display-${id}`)

    newCanvas.width = oldCanvas.width
    newCanvas.height = oldCanvas.height

    context.drawImage(oldCanvas, 0, 0)

    parent.innerHTML = ''
    parent.appendChild(newCanvas)
}

const EntityPreview = ({entity, isModalOpen}) => {
    useEffect(() => {
        if (isModalOpen) {
            mountPreview(entity)
        }
    }, [entity, isModalOpen])

    return <div id={`entity-preview-display-${entity.id}`} />
}

export default EntityPreview
